document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '.product-grid',
    pagination: '.pagination'
  });

  document.addEventListener('filters-applied', function() {
      endlessScroll = new Ajaxinate({
        container: '.product-grid',
        pagination: '.pagination'
      });
  });

  const swiper_main = new Swiper('.product-slider', {
      loop:true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      }
  });

  const swiper_reviews = new Swiper('.review-items-slider', {
      slidesPerView: 1,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: { crossFade: true }
  });

  swiper_main.on('slideChange', () => {
    swiper_reviews.slideToLoop(swiper_main.realIndex);
  });

  swiper_reviews.on('slideChange', () => {
    swiper_main.slideToLoop(swiper_reviews.realIndex);
  });

  if(window.innerWidth < 768){
      $('div#related-catalogs .catalog-wrapper').addClass('swiper');
      $('div#related-catalogs .catalog-wrapper').append(`<div><div class="pagination-container"><span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span><span class="swiper-pagination-bullet"></span><span class="swiper-pagination-bullet"></span><span class="swiper-pagination-bullet"></span></div><div id="prev-related-catalog" class="swiper-button-prev horizontal swiper-button-disabled"></div><div id="next-related-catalog" class="swiper-button-next horizontal"></div></div>`);
      $('div#related-catalogs .catalog-grid').addClass('swiper-wrapper');
      $('div#related-catalogs').find('.catalog-item').addClass('swiper-slide');

      const swiper_catalog = new Swiper('.catalog-wrapper', {
          slidesPerView: 1.9,
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.pagination-container',
            clickable: true,
          }
      });

      $(document).on('click', '.product-card .open-details, .product-card .hide-details', function () {
          const $this = $(this);
          const $card = $this.closest('.product-card');
      
          if ($this.hasClass('open-details')) {
              $this.removeClass('open-details').addClass('hide-details');
          } else {
              $this.removeClass('hide-details').addClass('open-details');
          }
      
          $card.toggleClass('active');
      });
  }

  if(window.innerWidth < 1024){
    function updateSidebarHeight() {
      if (window.innerWidth < 1024) {
        const header = document.querySelector('.header-group');
        if (!header) return;
    
        const headerRect = header.getBoundingClientRect();
        const visibleHeaderHeight = Math.max(0, headerRect.bottom); // how much of the header is visible
    
        const sidebarHeight = window.innerHeight - visibleHeaderHeight;
        $('html').css('--sidebar-height', sidebarHeight+'px');
      }
    }
  
    updateSidebarHeight();
  
    window.addEventListener('resize', updateSidebarHeight);
    window.addEventListener('scroll', updateSidebarHeight);

    // Open the sort panel
    $(document).on('click', 'button.sort-button', function () {
      $(document).find('.cc-filters-container').addClass('open-sort');
      $(document).find('details.cc-filter--sort').addClass('custom-open');
    });
  
    // Close on label click inside the sort filter
    $(document).on('click', 'details.cc-filter--sort label', function () {
      $(document).find('.cc-filters-container').removeClass('open-sort');
      $(document).find('details.cc-filter--sort').removeClass('custom-open');
    });
  
    // Close on custom close button
    $(document).on('click', '.cc-sort-label button.custom-close-sort', function () {
      $(document).find('.cc-filters-container').removeClass('open-sort');
      $(document).find('details.cc-filter--sort').removeClass('custom-open');
    });

    $(document).on('click', '.filters-open .main-nav-bar', function () {
        $(document).find('button.cc-filter-close-btn').click();
    })
  }
});